import axiosInstance from '@/services'
import { defineStore } from 'pinia'

export const useEstablishmentStore = defineStore('establishment', {
  state: () => {
    return { uaePassConfig: null, canToggleUserProfile: false }
  },
  getters: {
    canToggleUserProfile() {
      return this.uaePassConfig?.enableActivateAndDeactivateUserProfiles || false
    },
    canUpdateMainUserProfileEmiratesId() {
      return this.uaePassConfig?.enableUpdateMainUserProfileEmiratesId || false
    }
  },
  actions: {
    async getUAEPassSetup() {
      const data = await axiosInstance.get('/api/uaepass/setup')
      this.uaePassConfig = data
    }
  }
})
